export default __webpack_public_path__ + "static/media/4.d05c64d0.jpg";